<app-header></app-header>

<app-tic-list></app-tic-list>

<app-footer></app-footer>
